
























































import { defineComponent, PropType, toRefs } from '@nuxtjs/composition-api';

import useMapServiceFactory from '@/components/map/functions/useMapServiceFactory';
import GoogleMapTypeEnum from '@/components/map/types/googleMapTypes';
import LoaderVue from '@/components/ui/loader.vue';
import IMarker from '~/components/map/types/marker/IMarker';

export default defineComponent({
  components: {
    LoaderVue,
  },
  props: {
    type: {
      type: Number as PropType<GoogleMapTypeEnum>,
      required: true,
    },
    markersProp: {
      type: Array as PropType<IMarker[]>,
      required: false,
      default: () => [],
    },
  },
  setup(props, { emit }) {
    return {
      ...useMapServiceFactory({
        emit,
        ...toRefs(props),
        loadStylesheet: (stylesheet: string) => import(`${stylesheet}`),
      }),
    };
  },
});
